<sd-mobile-login-button *ngIf="deviceService.isTabletMdDown$ | async; else desktopLogin"></sd-mobile-login-button>

<ng-template #desktopLogin>
  <sd-desktop-login-button></sd-desktop-login-button>
</ng-template>
